export const TERMS_AND_CONDITION_URL =
  "https://halteverbot24.de/wp-content/uploads/2023/05/AGB_Halteverbot24.de_.pdf";

// parent window that renders this site in iframe
export const LOCAL_PARENT_URL = "http://127.0.0.1:5500"; // only for test
export const PARENT_WORDPRESS_URL = process.env.REACT_APP_WORDPRESS as string;
